<template>
  <div class="input">
    <label>{{ label }}</label>
    <input v-model="title" />
  </div>
</template>

<script>
export default {
  name: 'TitleInput',
  props: {
    label: String,
  },
  computed: {
    title: {
      get() { return this.$store.state.title; },
      set(value) { this.$store.commit('setTitle', value); },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input {
  max-width: 50%;
  text-align: right;
}
</style>
